// @flow
import React, { PureComponent } from 'react';
import type { Node } from 'react';
import PropTypes from 'prop-types';

// Components
import Select from 'Common/Select';
import Input from 'Common/Input';

// Helpers
import classNames from 'classnames';

import { withinDistanceValues } from 'Common/filterValues';

import {
  getPriceFromValues,
  getPriceToValues
} from 'Common/calculatePriceIncrements';

import { getKey } from 'Common/formValues';

/**
 * <BasicFilters /> component.
 * @return {class} returns basicfilters instance
 */
class BasicFilters extends PureComponent<*, *> {
  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   * @prop {string} topRowClasses - topRowClasses.
   * @prop {object} styles - styles.
   * @prop {object} bootstrap - bootstrap.
   * @prop {array} makes - makes.
   * @prop {array} models - models.
   * @prop {function} checkPostcode - checkPostcode.
   * @prop {number} priceFrom - priceFrom.
   * @prop {number} priceTo - priceTo.
   * @prop {object} fields - fields.
   * @prop {function} resetField - resetField.
   */
  static propTypes = {
    topRowClasses: PropTypes.string.isRequired,
    styles: PropTypes.object.isRequired,
    bootstrap: PropTypes.object.isRequired,
    makes: PropTypes.array,
    models: PropTypes.array,
    checkPostcode: PropTypes.func.isRequired,
    fields: PropTypes.object.isRequired,
    isPostcodeValid: PropTypes.bool.isRequired,
    priceFrom: PropTypes.number,
    priceTo: PropTypes.number,
    resetField: PropTypes.func,
    isResultsLoading: PropTypes.bool,
    setPostcodeRef: PropTypes.func,
    highlight: PropTypes.bool
  };

  /**
   * Renders <BasicFilters /> component.
   *
   * @return {JSX} - renders a logo.
   */
  render(): Node {
    const {
      topRowClasses,
      styles,
      bootstrap,
      makes,
      models,
      checkPostcode,
      fields,
      isPostcodeValid,
      priceFrom,
      priceTo,
      resetField,
      isResultsLoading,
      resultsLength,
      disableSearchButton,
      scrollToPostCodeRef,
      setPostcodeRef,
      highlight,
      isMobile
    } = this.props;

    return (
      <div className={topRowClasses}>
        <div className={classNames(styles.formRowItem)}>
          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'make'}
            label={'Select make (any)'}
            options={makes}
            selectedValue={fields.make}
            resetField={resetField}
            isDisabled={isResultsLoading}
            isMobile={isMobile}
          />
        </div>

        <div className={classNames(styles.formRowItem)}>
          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'model'}
            label={'Select model (any)'}
            options={models}
            selectedValue={fields.model}
            isDisabled={!fields.make || isResultsLoading}
            isMobile={isMobile}
          />
        </div>

        <div className={classNames(styles.formRowItem)}>
          <div className={classNames(styles.doubleSelect)}>
            <Select
              styles={styles}
              bootstrap={bootstrap}
              name={'minPrice'}
              label={'Price from'}
              options={getPriceFromValues(
                priceFrom,
                priceTo,
                getKey(fields.maxPrice)
              )}
              selectedValue={fields.minPrice}
              disableCount={true}
              borderRight={true}
              isPrice={true}
              isDisabled={isResultsLoading}
              isMobile={isMobile}
            />

            <Select
              styles={styles}
              bootstrap={bootstrap}
              name={'maxPrice'}
              label={'Price to'}
              options={getPriceToValues(
                priceFrom,
                priceTo,
                getKey(fields.minPrice)
              )}
              selectedValue={fields.maxPrice}
              disableCount={true}
              isPrice={true}
              isDisabled={isResultsLoading}
              isMobile={isMobile}
            />
          </div>
        </div>

        <div className={classNames(styles.formRowItem)}>
          <div
            className={classNames(styles.doubleSelect, styles.fullWidthMobile)}
          >
            <Input
              styles={styles}
              bootstrap={bootstrap}
              name={'postCode'}
              label={'Postcode'}
              onChangeHandler={checkPostcode}
              // onBlurHandler={this.gtmPushPostcode}
              selectedValue={fields.postCode}
              showIcon={true}
              placeholderText={'Postcode'}
              isValid={isPostcodeValid}
              errorMessage={'Please enter a valid UK postcode'}
              isLoading={isResultsLoading}
              resetField={resetField}
              setRef={setPostcodeRef}
              highlight={highlight}
            />

            <Select
              styles={styles}
              bootstrap={bootstrap}
              name={'withinDistance'}
              label={'Distance'}
              options={withinDistanceValues}
              selectedValue={fields.withinDistance}
              isDisabled={!isPostcodeValid}
              disableCount={true}
              isMobile={isMobile}
            />
          </div>
        </div>
        <div className={classNames(styles.formRowItem)}>
          <button
            className={classNames(
              bootstrap.btn,
              bootstrap.btnSecondary,
              bootstrap.btnLg,
              styles.searchButton
            )}
            onClick={scrollToPostCodeRef}
            type="submit"
            disabled={disableSearchButton || !resultsLength}
          >
            <span>Search </span>
            {!isResultsLoading && (
              <span className={classNames(styles.result)}>
                {resultsLength && resultsLength.toLocaleString('en')}
              </span>
            )}
            <span> results</span>
          </button>
        </div>
      </div>
    );
  }
}

export default BasicFilters;



// WEBPACK FOOTER //
// ./src/Home/BasicFilters/index.js